
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employees/register",
      function () {
        return require("private-next-pages/employees/register.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employees/register"])
      });
    }
  